import { useContext, useState } from "react"
import Select from "react-select";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import Loader from "../../Common/Loader";
import SchoolContext from "../../../Context/SchoolContext";
import SystemModal from "../../Common/SystemModal";


const PrintFilterBonusForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const {schoolList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");
    const [hasData, setHasData] = useState(false);
    const [localList, setLocalList] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxStudent.printAllActivationBonusStudents(school, startDate, endDate);
        setLoading(false);
        if(server_response.status==="OK"){
            const list = server_response.details.data || [];
            props.g(list);
            setLocalList(list);
            setHasData(list.length > 0);
        }
        else{
            props.g(false)
            setLocalList([]);
            setHasData(false);
        } 
    }

    const handleExport = () => {
        props.h(localList);
    };
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    {!hasData? <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>:
                    <button
                        type="button"
                        className="btn-fill-md text-light bg-success ml-2"
                        onClick={handleExport}
                        disabled={!hasData}
                    >
                        Export<i className="fas fa-file-export mg-l-15"></i>
                    </button>}
                    </>
        }
    }

    return(
        <SystemModal
            title="Export Student List"
            id="model-bonus-students"
            size="md"
            footer={RenderFooter}
        >  
            
            <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Start Date:</label>
                <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
            </div>
                
            
            <div className="mb-4 form-group border-1">
                <label htmlFor="">End Date:</label>
                <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
            </div>
        
       
        </SystemModal>
    )
}

export default PrintFilterBonusForm
